<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Acompanhamentos' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <ion-card *ngFor="let historico of historicoList">
    <ion-card-content>
      <div>
        <ion-row>
          <ion-col size="2">
            <i [ngStyle]="{'color': getFontColor(historico)}" class="{{getIcon(historico)}} icone-acompanhamento"></i>
            <br>
          </ion-col>

          <ion-col size="10" class="item-content">
            <h2 class="grupo">
              {{historico.acao}}
            </h2>
            <div class="item-description">
              <p class="description-text">
                <span class="bold-1" text-uppercase>{{historico.categoria}}</span>
              </p>
            </div>
          </ion-col>
        </ion-row>

        <div class="item-description">
          <i class="fa-solid fa-circle-info"></i>
          <p class="description-text ion-justify-content-center	">
            <span class="bold-1"
              [ngClass]="{'green': historico.tipo == '0', 'red': historico.tipo == '2', 'orange': historico.tipo == '1'}"
              text-uppercase> {{historico.status}}</span>
          </p>
        </div>

        <div class="item-description">
          <i class="fa-solid fa-calendar-days"></i>
          <p class="description-text">
            <span class="bold-1" text-uppercase> {{historico.datahora | dateFormat: "mediaHora"}} </span>
          </p>
        </div>

        <div class="item-description">
          <i class="fa-solid fa-eye"></i>
          <p class="description-text text-left">
            <span class="bold-1" text-uppercase>
              {{historico.restrito == '1' ? ('RESTRITO' | translate) : ('PÚBLICO' | translate)}} </span>
          </p>
        </div>
      </div>

      <div class="down">
        <button class="btn-detalhes" (click)="detalhes(historico)" type="button">{{'Detalhes' |
          translate}}</button>
      </div>
    </ion-card-content>
  </ion-card>

  <sem-registro *ngIf="!historicoList.length"></sem-registro>
</ion-content>